import { useEffect, useState, useRef } from "react";
import axios from "axios";
import SmsTranscationDist from "./SmsTranscationDist";

function SmsTranscationsInt() {

  const [month, setMonth] = useState([]);
  const [year, setYear] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const date = new Date();
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth() + 1;

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedVendor, setSelectedVendor] = useState("");

  const [renderContent, setRenderContent] = useState(null);
  const currentTableRef = useRef(null);

  const handleSubmit = () => {
    if (!selectedMonth || !selectedYear) {
      alert("Please select month and year");
      return;
    }

    if (currentTableRef.current) {
      const { bottom } = currentTableRef.current.getBoundingClientRect();
      window.scrollTo({
        top: window.scrollY + bottom + 10,
        behavior: "smooth",
      });
    }

    setRenderContent(
      <SmsTranscationDist
        month={selectedMonth}
        year={selectedYear}
        vendor={selectedVendor}
      />
    );
  };

  useEffect(() => {

    // Months API
    axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/putMonths`)
      .then(response => {
        const doc = new DOMParser().parseFromString(response.data, "text/html");
        const values = Array.from(doc.querySelectorAll("option"))
          .map(opt => Number(opt.value))
          .filter(v => v >= 1 && v <= 12);
        setMonth(values);
      })
      .catch(err => console.error("Month error:", err));

    // Years API
    axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/putYears`)
      .then(response => {
        const doc = new DOMParser().parseFromString(response.data, "text/html");
        const values = Array.from(doc.querySelectorAll("option"))
          .map(opt => Number(opt.value))
          .filter(v => v > 2000);
        setYear(values);
      })
      .catch(err => console.error("Year error:", err));

    axios.get(`${process.env.REACT_APP_URL_SIDE}/Sucess/vendorsType`)
      .then(res => {

        setVendorList(res.data.vendorList);
      })
      .catch(err => console.error("Vendor error:", err));

  }, []);

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const getMonthName = (m) => months[m - 1] || "Invalid";

  return (
    <div className="wrapper row3">
      <br></br>
      <table align="center" border={1} ref={currentTableRef} width="35%">
        <thead>
          <tr className="tableheader">
            <th colSpan={6}>Sms Sent Transaction</th>
          </tr>
        </thead>

        <tbody>
          {/* SAME ROW */}
          <tr>
            <td>Month:</td>
            <td>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
              >
                {month.length === 0
                  ? <option>Loading...</option>
                  : month.map((m, i) => (
                    <option key={i} value={m}>
                      {getMonthName(m)}
                    </option>
                  ))}
              </select>
            </td>

            <td>Year:</td>
            <td>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
              >
                {year.length === 0
                  ? <option>Loading...</option>
                  : year.map((y, i) => (
                    <option key={i} value={y}>{y}</option>
                  ))}
              </select>
            </td>
            <td>Type:</td>
            <td>
              <select
                value={selectedVendor}
                onChange={(e) => setSelectedVendor(e.target.value)}
              >
                <option value="">All</option>
                {vendorList.map((v, i) => (
                  <option key={i} value={v}>{v}</option>
                ))}
              </select>
            </td>
          </tr>

          <tr>
            <td colSpan={6} align="center">
              <button className="button button2" onClick={handleSubmit}>
                Submit
              </button>
              <button className="button button2" onClick={() => window.history.back()}>
                Back
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <br /><br />
      {renderContent}

    </div>
  );
}

export default SmsTranscationsInt;